<template>
  <select
    v-model="selected"
    :class="[{'spl-select--invalid': invalid}, 'spl-select']">
    <option
      v-for="(option, index) in options"
      :key="'formSelectOption' + index"
      :value="option.value">
      {{ option.label }}
    </option>
  </select>
</template>

<script>
import { find } from 'lodash'
export default {
  name: 'FormSelect',
  props: ['options', 'value', 'id', 'invalid'],
  data () {
    return {
      selected: this.value.value
    }
  },
  watch: {
    selected: function (newVal, oldVal) {
      this.$emit('valueSelected', find(this.options, { value: newVal }), this.id)
    }
  }
}
</script>

<style lang="scss">
@import '../../variables.scss';

.spl-select {
  appearance: none;
  background-color: #fff;
  font-family: "Open Sans", sans-serif;
  border: 1px solid #dbd3c5;
  border-radius: 4px;
  padding: 5px 5px 5px 10px;
  width: 100%;
  height: 34px;
  font-size: 14px;
  cursor: pointer;
  transition: opacity 150ms ease-in-out;
  background: url(../../assets/icon-dropdown-arrow.svg) calc(100% - 20px) / 13px #eee no-repeat;
  &--invalid {
    border: 1px solid $errorRed;
  }
}

.spl-select::-ms-expand {
  display: none;
}
</style>
